"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoggers = void 0;
function createLoggers(namespace) {
    if (namespace === void 0) { namespace = ''; }
    var info = function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        console.info.apply(console, __spreadArray(["%c[edgets-common][" + namespace + "]", 'color: #b19cd9'], rest, false));
    };
    var error = function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        console.error.apply(console, __spreadArray(["%c[edgets-common][" + namespace + "]", 'color: #b19cd9'], rest, false));
    };
    var warn = function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        console.warn.apply(console, __spreadArray(["%c[edgets-common][" + namespace + "]", 'color: #b19cd9'], rest, false));
    };
    var debug = function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        console.debug.apply(console, __spreadArray(["%c[edgets-common][" + namespace + "]", 'color: #b19cd9'], rest, false));
    };
    return {
        info: info,
        error: error,
        warn: warn,
        debug: debug,
    };
}
exports.createLoggers = createLoggers;
